import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/webforyou.svg';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-8 mt-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <Link to="/">
              <img src={logo} alt="WebForYou Support" className="h-8 w-auto" />
            </Link>
            <p className="text-sm">
              Professzionális IT támogatás és szolgáltatások vállalkozások számára
            </p>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Elérhetőség</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a 
                  href="tel:+36709083086" 
                  className="hover:text-purple-400 transition-colors"
                >
                  +36 70 908 3086
                </a>
              </li>
              <li>
                <a 
                  href="mailto:support@webforyou.hu"
                  className="hover:text-purple-400 transition-colors"
                >
                  support@webforyou.hu
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Szolgáltatások</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/szolgaltatasok#szerverek" className="hover:text-purple-400 transition-colors">
                  Szerverek
                </Link>
              </li>
              <li>
                <Link to="/szolgaltatasok#halozat" className="hover:text-purple-400 transition-colors">
                  Hálózat
                </Link>
              </li>
              <li>
                <Link to="/szolgaltatasok#tamogatas" className="hover:text-purple-400 transition-colors">
                  Felhasználói Támogatás
                </Link>
              </li>
              <li>
                <Link to="/szolgaltatasok#eszkozok" className="hover:text-purple-400 transition-colors">
                  Eszköz Beszerzés
                </Link>
              </li>
              <li>
                <Link to="/szolgaltatasok#biztonsag" className="hover:text-purple-400 transition-colors">
                  Biztonságtechnika
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Követés</h3>
            <div className="flex space-x-4">
              <a 
                href="https://facebook.com/webforyou" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-purple-400 hover:text-purple-300"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="#" className="text-purple-400 hover:text-purple-300">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
              <a href="#" className="text-purple-400 hover:text-purple-300">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0C5.373 0 0 5.373 0 12c0 5.623 3.872 10.328 9.092 11.63-.056-.162-.092-.35-.092-.583v-2.051c-1.57.282-1.99-.618-2.12-.936-.282-.75-.706-1.026-1.27-1.026-.37 0-.83.37-.83.37 0 .37.46.47.777.777.37.37 1.116 1.116 1.116 2.232 0 1.116-.777 1.993-1.993 1.993-1.216 0-1.993-.877-1.993-1.993 0-1.116.777-1.993 1.993-1.993.37 0 .83.37.83.37s-.46-.47-.777-.777c-.37-.37-1.116-1.116-1.116-2.232 0-1.116.777-1.993 1.993-1.993 1.216 0 1.993.877 1.993 1.993 0 .37-.37.83-.37.83s.47-.46.777-.777c.37-.37 1.116-1.116 1.116-2.232 0-1.116-.777-1.993-1.993-1.993zm0 13.86c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-center">
          <p>&copy; {new Date().getFullYear()} WebForYou Support. Minden jog fenntartva.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 